import React, { useCallback, useState, useEffect } from "react"

import { Dropdown, DropdownButton } from "react-bootstrap"

import TagDefinitionsPopper from "./TagDefinitionsPopper"
import { cleanObservationAxisAssignment } from "../../resources/utils"
import { deepcopy } from "../../../utils"

export default function UnitsSelectorAndTagInfo({ obs, tagData, graphKey, plotConfigUpdater, tag_category }) {
  const { tag, units } = obs

  const [unitOpts, setUnitOpts] = useState([])
  useEffect(() => {
    setUnitOpts([...new Set([units, ...(tagData?.unit_alternatives || [])])])
  }, [units, tagData.unit_alternatives])

  const [currentUnits, setCurrentUnitsState] = useState(units || "")
  useEffect(() => {
    setCurrentUnitsState(units)
  }, [units])
  const setCurrentUnits = useCallback(
    (u) => {
      if (u !== currentUnits) {
        onUnitsChange(u, tag)
      }
    },
    [currentUnits],
  )

  const onUnitsChange = useCallback(
    (u, t) => {
      let graph = deepcopy(graphKey)
      let obs_variables = []
      if (["multi", "site-wide"].includes(graph.special)) {
        obs_variables = ["tags", "observations"]
      } else {
        obs_variables = [tag_category]
      }

      obs_variables.forEach((metric) => {
        if (Object.keys(graph).includes(metric)) {
          graph[metric] = graph[metric].map((obv) => {
            /*
             * Doing a match only on 'tag' here assumes that units for a given tag must stay
             * consistent regardless of source (e.g. 'Ethanol' across all runs on a multi-run plot or online 'Ethanol'
             * plotted alongside offline 'Ethanol')
             */
            if (obv.tag !== t) return obv

            return {
              ...obv,
              units: u,
            }
          })
        }
      })

      graph = cleanObservationAxisAssignment(graph[tag_category], graph, tag_category)

      plotConfigUpdater(graph)
    },
    [graphKey, plotConfigUpdater, tag_category],
  )

  return (
    <>
      <DropdownButton
        title={currentUnits}
        variant={"outline-primary"}
        className={"select-option local-btn-sm"}
        disabled={unitOpts.length <= 1 || tagData.disabled}
      >
        {unitOpts.map((opt) => (
          <Dropdown.Item key={opt} onClick={() => setCurrentUnits(opt)}>
            {opt}
          </Dropdown.Item>
        ))}
      </DropdownButton>
      <>
        &nbsp;
        <TagDefinitionsPopper
          title={
            tagData.label || tagData.tag_label ? `${tagData.label || tagData.tag_label} [${tag}]` : `${tag}`
          }
          tag={tag}
          tagData={tagData}
        />
      </>
    </>
  )
}
